// extracted by mini-css-extract-plugin
export var localeSelector = "_bg-0";